/**
 * @ngdoc service
 * @name BB.bbWidgetModal
 *
 * @description
 * bbWidgetModal handles opening and closing of $uibModal modals
 *
 */

export class BBWidgetModal {
    constructor($rootScope, $uibModal, $uibModalStack, AlertService) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$uibModalStack = $uibModalStack;
        this.AlertService = AlertService;
    }

    /***
     * @ngdoc method
     * @name openModal
     * @methodOf BB:bbWidgetModal
     * @description
     * Initialises $uibModal modal
     * @param {Object} config The config to initialise the modal with
     *
     * @returns {Promise} the promise returned by $uibModal
     */
    openModal(config) {
        const controller = ($scope, bbWidgetModal, config) => {
            $scope.config = config;
            $scope.cancel = () => bbWidgetModal.close();
        };

        const resolve = { config: () => config };
        const modalOptions = {
            templateUrl: config.templateUrl,
            controller,
            resolve,
            size: 'lg'
        };

        return this.$uibModal.open(modalOptions);
    }

    /***
     * @ngdoc method
     * @name close
     * @methodOf BB:bbWidgetModal
     * @description
     * Closes $uibModal modal
     */
    close() {
        this.AlertService.clear();
        const openModal = this.$uibModalStack.getTop();
        this.$uibModalStack.close(openModal.key);
    }
}

angular
    .module('BB')
    .service('bbWidgetModal', BBWidgetModal);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/widget-modal/bb_widget_modal.service.js